@let user = selectedUser();
<button
  mat-stroked-button
  type="button"
  class="assign-button"
  data-testid="inbox-assign-button"
  [disabled]="assigning()"
  [glxyPopover]="assignPopover"
  (click)="retryFailedUsersLoad(); assignPopover.open()"
  [attr.aria-label]="
    $assigneeState() === 'unassigned'
      ? ('INBOX.STRIP.ASSIGN_CONVERSATION' | translate)
      : ('INBOX.STRIP.REASSIGN_CONVERSATION' | translate: { name: user?.displayName })
  "
>
  <span class="assign-button-content">
    @if (assigning()) {
      <glxy-loading-spinner size="small"></glxy-loading-spinner>
    } @else if ($assigneeState() === 'unassigned') {
      <mat-icon>person_add</mat-icon>
      <span class="assign-label">{{ 'INBOX.STRIP.ASSIGN' | translate }}</span>
    } @else if (resolvingName() && !user?.displayName) {
      <glxy-loading-spinner size="small"></glxy-loading-spinner>
    } @else {
      <glxy-avatar [width]="20" [name]="user?.displayName || '?'"></glxy-avatar>
      <span class="assign-label assignee-name">
        {{ user?.displayName || ('INBOX.STRIP.UNKNOWN_USER' | translate) }}
      </span>
    }
  </span>
</button>

<glxy-popover
  #assignPopover
  padding="small"
  [positions]="popoverPositions"
  [hasArrow]="false"
  [keepOnScreen]="true"
  [closeOnBackdropClick]="true"
  [closeOnEscapeKey]="true"
>
  <div class="assign-popover-content">
    @let showAssignToMe = $assigneeState() !== 'assigned-to-me' && $canAssignToMe();
    @let showRemoveAssignee = $assigneeState() !== 'unassigned';
    @if (showAssignToMe) {
      <button type="button" class="popover-action-row" (click)="assignToMe(); assignPopover.close()">
        <mat-icon>person</mat-icon>
        <span>{{ 'INBOX.STRIP.ASSIGN_TO_ME' | translate }}</span>
      </button>
    }
    @if (showRemoveAssignee) {
      <button type="button" class="popover-action-row" (click)="assignUser(null); assignPopover.close()">
        <mat-icon>person_remove</mat-icon>
        <span>{{ 'INBOX.STRIP.REMOVE_ASSIGNEE' | translate }}</span>
      </button>
    }
    @if (showAssignToMe || showRemoveAssignee) {
      <hr class="popover-divider" />
    }
    <glxy-form-field appearance="outline" size="small" bottomSpacing="none">
      <input
        matInput
        type="text"
        [formControl]="searchControl"
        [matAutocomplete]="userAuto"
        [placeholder]="'INBOX.STRIP.SEARCH_USERS' | translate"
        autocomplete="off"
      />
      <mat-autocomplete
        #userAuto
        [displayWith]="displayUser"
        (optionSelected)="onUserSelected($event); assignPopover.close()"
      >
        @if ($loadingUsers()) {
          <mat-option disabled>
            <div class="user-option">
              <glxy-loading-spinner size="small"></glxy-loading-spinner>
              <span class="user-option-name">{{ 'INBOX.STRIP.LOADING_USERS' | translate }}</span>
            </div>
          </mat-option>
        } @else if ($usersLoadFailed()) {
          <mat-option disabled>{{ 'INBOX.STRIP.USERS_LOAD_FAILED' | translate }}</mat-option>
        }
        @for (option of users$ | async; track option.userId) {
          <mat-option [value]="option">
            <div class="user-option">
              <glxy-avatar [width]="24" [name]="option.displayName"></glxy-avatar>
              <span class="user-option-name">{{ option.displayName }}</span>
            </div>
          </mat-option>
        }
        @if (!$loadingUsers() && !$usersLoadFailed() && (users$ | async)?.length === 0 && searchControl.value) {
          <mat-option disabled>{{ 'INBOX.STRIP.NO_USERS_FOUND' | translate }}</mat-option>
        }
      </mat-autocomplete>
    </glxy-form-field>
  </div>
</glxy-popover>
